import { ChangeDetectorRef, Component, EventEmitter, HostListener, OnInit, Output } from '@angular/core';
import { GlobalService } from '@commoncore/services/global.service';
import { AppEvents } from '@commoncore/utils/app-events';
import { TrashController } from '@mainrepo/app/core/controller/TrashController';
import { DependenciesModule } from '@modules/dependencies/dependencies.module';

@Component({
  standalone:true,
  selector: 'app-delete-permanant',
  templateUrl: './delete-permanant.component.html',
  styleUrls: ['./delete-permanant.component.scss'],
  imports:[DependenciesModule]
})
export class DeletePermanantComponent implements OnInit {
  @Output() close = new EventEmitter();
  @Output() confirmDeletion = new EventEmitter();
  public universalService:any;
  public listService:any;
  showParmanentDeleteModal:boolean = false;
  controller: any;
  implRef: any;
  contextMenuOpsService:any;
  constructor(public globalService:GlobalService,private changeDetector:ChangeDetectorRef) { 
    this.setEnvObjects(this.globalService);
  }

  @HostListener('document:keydown', ['$event'])
  onKeyDownHandler(event: KeyboardEvent) {
    if (event.key === "Escape" && this.showParmanentDeleteModal) {
      this.listService.deSelectAll(event)
    }else if(event.key === "Enter" && this.showParmanentDeleteModal){
      this.deleteForever()
    }
  }

  ngOnInit(): void {
    let classRef = this;
    this.controller = TrashController.getInstance(this.globalService);
    this.implRef = this.controller.trashImplementation;
    this.controller.setEnvObjects(this.globalService);
    AppEvents.optionSelected.subscribe(event => {
      console.log("deleteforever", event)
      if(event["deleteforever"]){
        classRef.showParmanentDeleteModal = event["deleteforever"];
        classRef.changeDetector.detectChanges();
      } else if(event["closeAll"]){
        classRef.showParmanentDeleteModal = false;
        classRef.changeDetector.detectChanges();
      }
     })
  }

  setEnvObjects(globalService) {
    this.universalService = globalService.getUniversalServiceRef();
    this.listService = globalService.getListServiceRef();
    this.contextMenuOpsService = globalService.getContextMenuOperationsServiceRef();
  }

  closePopUp(){
    this.universalService.popUpToBeOpened = "";
    this.universalService.openMoreOptions = false;
    this.universalService.showMobOptionMenu = false;
    this.showParmanentDeleteModal = false;
    // this.changeDetector.detectChanges();
    this.close.emit();
  }

  deleteForever(){
    if(this.universalService.selectedTab == "TeamsFolderOperations"){
      this.contextMenuOpsService.deleteTrashedObject(this.universalService.selectedNodes);
    }else{
      this.controller.deleteForever();
    }
    
  }

}
